import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
import { CheckApproval } from "@/models/approval/ApprovalResponse";
import { DataTableHeader } from "vuetify";
import ApprovalChip from "@/components/approval/table/ApprovalChip.vue";
import { DateTime } from "luxon";

type Props = {
  items: CheckApproval[];
};

type ClickRowSlot = {
  expand: (value: boolean) => void;
  headers: DataTableHeader[];
  isExpanded: boolean;
  isMobile: boolean;
  isSelected: boolean;
  item: unknown;
  select: (value: boolean) => void;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'TableBase',
  props: {
    items: null
  },
  setup(__props: any) {



const headers: DataTableHeader[] = [
  { text: "申請日", value: "requestDate", divider: true },
  { text: "対象日付", value: "petitionDate", divider: true },
  { text: "社員コード", value: "employeeCode", divider: true },
  { text: "社員名", value: "employeeName", divider: true },
  { text: "所属名", value: "affiliationName", divider: true },
  {
    text: "承認状態",
    value: "approvalState",
    divider: true,
    align: "center",
    sortable: false,
    width: 100
  },
  { text: "", value: "data-table-expand" }
];

const expanded = ref<CheckApproval[]>([]);

const onClickRow = (_: unknown, slot: ClickRowSlot) => {
  slot.expand(!slot.isExpanded);
};
const itemClass = (item?: CheckApproval) => {
  expanded.value.some(e => e.recordId === item?.recordId)
    ? "yellow accent-1"
    : "";
};
const formatDate = (date: string) => {
  return DateTime.fromISO(date)
    .setLocale("ja")
    .toFormat("yyyy年MM月dd日(EEE)");
};

return { __sfc: true,headers, expanded, onClickRow, itemClass, formatDate, ApprovalChip }
}

})